var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fileUploads.length
    ? _c(
        "ul",
        { class: _vm.context.classes.files },
        [
          _vm._l(_vm.fileUploads, function(file) {
            return _c(
              "li",
              {
                key: file.uuid,
                attrs: {
                  "data-has-error": !!file.error,
                  "data-has-preview": !!(_vm.imagePreview && file.previewData)
                }
              },
              [
                _c(
                  "FormulateSlot",
                  {
                    attrs: {
                      name: "file",
                      context: _vm.context,
                      file: file,
                      "image-preview": _vm.imagePreview
                    }
                  },
                  [
                    _c(_vm.context.slotComponents.file, {
                      tag: "component",
                      attrs: {
                        context: _vm.context,
                        file: file,
                        "image-preview": _vm.imagePreview
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                file.error
                  ? _c("div", {
                      class: _vm.context.classes.fileUploadError,
                      domProps: { textContent: _vm._s(file.error) }
                    })
                  : _vm._e()
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.isMultiple && _vm.context.addLabel
            ? _c(
                "div",
                {
                  class: _vm.context.classes.fileAdd,
                  attrs: { role: "button" }
                },
                [
                  _vm._v("\n    " + _vm._s(_vm.context.addLabel) + "\n    "),
                  _c("input", {
                    ref: "addFiles",
                    class: _vm.context.classes.fileAddInput,
                    attrs: { type: "file", multiple: "" },
                    on: { change: _vm.appendFiles }
                  })
                ]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }